export default __webpack_public_path__ + "static/media/arrow.7d12153b.svg";